// Typed Hono RPC client for apps/api, built from that app's own route types
// (see apps/api/src/core/app.ts's `AppType`), so a call like
// `client.dashboard.overview.$get()` is checked against the real request and
// response shapes at build time instead of being hand-typed and left to drift.
//
// The `AppType` import below is `import type` only, so Bun's transpiler
// elides it entirely from the bundle: apps/api's runtime code (Postgres,
// Redis, S3, OpenAI clients) never ships to the browser.
import { hc } from "hono/client";
import type { AppType } from "@bot-whatsapp/api/src/core/app";

export const DEFAULT_API_URL = "http://localhost:3001";

// `process.env.API_URL` is replaced at build time by Bun.build's `define`
// (apps/web/build.ts), so the browser bundle carries the literal origin.
// Under `bun` itself (tests, scripts) the same expression reads the real env.
// A same-origin deploy sets API_URL to the web origin.
export const apiBaseUrl: string = process.env.API_URL || DEFAULT_API_URL;

export type ApiClient = ReturnType<typeof hc<AppType>>;

export function createApiClient(
  baseUrl: string = apiBaseUrl,
  options: { headers?: Record<string, string>; fetch?: typeof fetch } = {},
): ApiClient {
  return hc<AppType>(baseUrl, options);
}

export const api = createApiClient();
